import { getSentry } from '../sentry/helper'
import { hasInstantiatedNewRelic } from '../newRelic/helper'

function logError(error: Error) {
  const sentry = getSentry()
  if (sentry && error) {
    sentry.captureException(error)
  }
   
  if (hasInstantiatedNewRelic && error && typeof newrelic !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    newrelic.noticeError(error)
  }
}

function logMessage(message: string) {
  const sentry = getSentry()
  if (sentry && message) {
    sentry.captureMessage(message)
  }
}

export { logError, logMessage }